import { render, staticRenderFns } from "./SharedIdResults.vue?vue&type=template&id=2afe4511&scoped=true&"
import script from "./SharedIdResults.vue?vue&type=script&lang=js&"
export * from "./SharedIdResults.vue?vue&type=script&lang=js&"
import style0 from "./SharedIdResults.vue?vue&type=style&index=0&id=2afe4511&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe4511",
  null
  
)

export default component.exports